export default "__VITE_ASSET__B0EeVMnp__"